import { ticketClient } from "@/api/index";
import { GetHourlyCollectionStatsReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
//小时级催收数据自动统计

interface Options {
  ItemId: number; // 工单分类
  pageIndex: number;
  pageSize: number;
  rank: number;
  sort?: number | string;
  Hour?: number;
  Statssort?: number;
  Statstype?: number;
  Timerange: string;
  Loantype?: number;
  AppName?: string
}

function hasValue(value: any) {
  return value !== undefined && value !== null && value !== "";
}

function buildRequest(arg: Options) {
  const request: any = new GetHourlyCollectionStatsReq();
  const statsType = Number(arg.Statstype || 4);
  request.setCommonin(setCommon());
  request.setItemid(Number(arg.ItemId) || 0);
  request.setAppname(arg.AppName || "");
  if (hasValue(arg.Loantype)) {
    request.setLoantype(Number(arg.Loantype));
  }
  request.setTimerange(arg.Timerange || "");
  if (hasValue(arg.Statssort)) {
    request.setStatssort(Number(arg.Statssort));
  }
  if (hasValue(arg.Statstype)) {
    request.setStatstype(statsType);
  }
  if ((statsType === 1 || statsType === 3) && hasValue(arg.Hour)) {
    request.setHour(Number(arg.Hour));
  }
  request.setPagein(
    setPage(arg.pageIndex, arg.pageSize, arg.sort, arg.rank)
  );
  console.log("request", request.toObject());
  return request;
}

export function getHourlyCollectionStatsReq(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      const request = buildRequest(arg);
      // setRank
      let _res = await ticketClient.getHourlyCollectionStats(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}

export function getHourlyCollectionStatsExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      const request = buildRequest(arg);
      let _res = await ticketClient.getHourlyCollectionStatsExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
